import { fromJS, Record } from 'immutable';
import {
  generateKeys,
  generateSchema,
} from '../../../../utils/helpers/model.helper';
import { ITrackingObject, TrackingObjectNamesEnum } from '../../tracking.data';

export const TRACKING_ACCOUNT_SCHEMA = Object.freeze({
  EMAIL: '',
  ACCOUNT_ID: '',
  I2G_USER_ID: '',
});
const RECORD = generateSchema(TRACKING_ACCOUNT_SCHEMA);
const KEYS: any = generateKeys(TRACKING_ACCOUNT_SCHEMA);

export class AccountTrackingObject
  extends Record(RECORD)
  implements ITrackingObject {
  static KEYS = KEYS;

  constructor(props?: any) {
    super(props && props.toMap ? props.toMap() : fromJS(props || {}));
  }

  get name() {
    return TrackingObjectNamesEnum.account;
  }

  get properties() {
    return this.toJS();
  }
}
